import { ChangeSourceType } from '../../lists/change-logs/change-source-type.enum';
import { RegisterUser } from './register-user.model';

export enum SignUpStatus {
  /**
   * A brand new Firebase Auth user and a brand new Agent record were created and bound.
   */
  createdNewAgent = 'createdNewAgent',

  /**
   * A Firebase Auth user already existed without binding; the system created a new Agent and bound it.
   */
  createdNewAgentAndRepairedBinding = 'createdNewAgentAndRepairedBinding',

  /**
   * An existing Agent record was found and bound to the Firebase Auth user (new or existing).
   */
  boundExistingAgent = 'boundExistingAgent',

  /**
   * A Firebase Auth user already existed without binding; the system bound the existing Agent.
   */
  repairedBindingToExistingAgent = 'repairedBindingToExistingAgent',

  /**
   * The email already has a Firebase Auth user bound to an Agent record; UI should show "email is already registered".
   */
  emailAlreadyRegistered = 'emailAlreadyRegistered',

  /**
   * More than one Agent login email record was found for the same email address.
   */
  conflictMultipleAgentsForEmail = 'conflictMultipleAgentsForEmail',

  /**
   * The request payload is invalid or incomplete.
   */
  invalidRequest = 'invalidRequest',

  /**
   * Unexpected error. The function should also log details to log-messages.
   */
  unknownError = 'unknownError',
}

/**
 * Payload that UI should send for registration to backend sign-up request.
 */
export interface SignUpRequest extends RegisterUser {
  /**
   * Optional change source type for audit trails.
   */
  actionName?: ChangeSourceType | null;
}

export interface SignUpResponse {
  status: SignUpStatus;
  email: string;

  /**
   * Firebase Auth user UID.
   */
  firebaseUserUid?: string | null;

  /**
   * Firestore Agent document identifier.
   */
  agentDbId?: string | null;

  /**
   * Human-readable message for debugging. UI should not rely on this for logic.
   */
  message?: string | null;
}

